import React, { useState, useCallback } from 'react';
import { Typography, Box, Modal, IconButton, Button } from '@mui/material';
import Background from '../../layout/Background';
import CloseIcon from '@mui/icons-material/Close';

const Artista2026 = React.memo(({ artista }) => {
    const [open, setOpen] = useState(false);

    // Memoizar handlers
    const handleOpen = useCallback(() => setOpen(true), []);
    const handleClose = useCallback(() => setOpen(false), []);

    return (
        <Box>
            <Box sx={{
                display: "flex",
                flexDirection: "column",
                gap: 1,
                alignItems: "center",
                width: { xs: "140px", sm: "180px", md: "200px", lg: "220px" },
            }}>
                <Box
                    sx={{
                        flexGrow: 1,
                        display: 'flex',
                        flexDirection: 'column',
                        justifyContent: 'center',
                        alignItems: 'center',
                        gap: 2,
                        boxSizing: 'border-box',
                    }}
                >
                    <Button sx={{
                        width: { xs: '140px', sm: '180px', md: '200px', lg: '220px' },
                        height: { xs: '140px', sm: '180px', md: '200px', lg: '220px' },
                        borderRadius: '50%',
                        border: '3px solid #D4A646',
                        overflow: "hidden",
                        cursor: 'default',
                        padding: 0,
                        // transition: 'opacity 0.2s ease',
                        // ":hover": {
                        //     opacity: 0.6,
                        // },
                    }}
                        // onClick={handleOpen}
                    >
                        <img 
                            src={artista.imagenPrincipal} 
                            alt={artista.nombre} 
                            style={{
                                width: '100%',
                                height: '100%',
                                objectFit: 'cover',
                                borderRadius: '50%',
                            }}
                            onError={(e) => {
                                console.error('Error cargando imagen:', artista.nombre);
                                e.target.src = '/assets/artistas/placeholder.jpg'; // Fallback
                            }}
                        />
                    </Button>
                    <Typography sx={{
                        color: '#FFFFFF',
                        fontSize: { xs: '16px', sm: '18px', md: '20px' },
                        textWrap: 'wrap',
                        textAlign: 'center',
                        width: "100%",
                        fontWeight: 500,
                    }}>
                        {artista.nombre}
                    </Typography>
                </Box>
            </Box>

            {/* Modal con galería de fotos */}
            <Modal
                open={open}
                onClose={handleClose}
                aria-labelledby="modal-artista-title"
                aria-describedby="modal-artista-description"
                disableAutoFocus
                disableEnforceFocus
                disableRestoreFocus
                sx={{
                    zIndex: 100000,
                }}
            >
                <Box sx={{
                    width: 'calc(100vw - 50px)',
                    height: 'calc(100vh - 50px)',
                    position: 'absolute',
                    top: '50%',
                    left: '50%',
                    overflow: "hidden",
                    transform: 'translate(-50%, -50%)',
                    borderRadius: '8px',
                }}>
                    <Background />
                    
                    {/* Botón de cerrar */}
                    <IconButton 
                        onClick={handleClose} 
                        sx={{
                            position: 'absolute',
                            top: '10px',
                            right: '10px',
                            backgroundColor: 'rgba(255,255,255,0.1)',
                            backdropFilter: 'blur(10px)',
                            color: '#FFFFFF',
                            borderRadius: '50%',
                            zIndex: 10,
                            "&:hover": {
                                backgroundColor: '#D4A646',
                            }
                        }}
                    >
                        <CloseIcon />
                    </IconButton>

                    {/* Contenido del modal */}
                    <Box sx={{
                        display: "flex",
                        flexDirection: "column",
                        gap: 4,
                        overflowY: "auto",
                        overflowX: "hidden",
                        height: "100%",
                        width: "100%",
                        padding: { xs: "20px", sm: '40px' },
                        boxSizing: 'border-box',
                        '&::-webkit-scrollbar': {
                            width: '10px',
                        },
                        '&::-webkit-scrollbar-thumb': {
                            backgroundColor: '#D4A646',
                            borderRadius: '10px',
                        },
                        '&::-webkit-scrollbar-track': {
                            backgroundColor: 'transparent',
                        },
                    }}>
                        {/* Header con imagen principal y nombre */}
                        <Box sx={{
                            display: "flex",
                            alignItems: { xs: 'center', sm: "flex-end" },
                            justifyContent: { xs: "space-between", sm: "flex-start" },
                            flexDirection: { xs: 'column', sm: 'row' },
                            gap: 4,
                        }}>
                            <img 
                                src={artista.imagenPrincipal} 
                                alt={artista.nombre}
                                style={{
                                    width: '300px',
                                    height: '300px',
                                    objectFit: 'cover',
                                    borderRadius: '50%',
                                    border: '4px solid #D4A646',
                                }} 
                            />
                            <Box sx={{
                                display: "flex",
                                flexDirection: "column",
                                justifyContent: "flex-end",
                            }}>
                                <Typography 
                                    variant="h2" 
                                    gutterBottom 
                                    sx={{
                                        color: '#FFFFFF',
                                        fontSize: { xs: '38px', sm: '54px' },
                                        fontWeight: 'bold',
                                    }}
                                >
                                    {artista.nombre}
                                </Typography>
                            </Box>
                        </Box>

                        {/* Galería de fotos (si hay más de una) */}
                        {artista.imagenes.length > 1 && (
                            <Box sx={{
                                display: 'flex',
                                flexDirection: 'column',
                                width: '100%',
                            }}>
                                <Typography gutterBottom sx={{
                                    color: '#FFFFFF',
                                    fontWeight: 'bold',
                                    fontSize: { xs: '24px', sm: '32px' },
                                    mb: 3,
                                }}>
                                    Galería de Fotos
                                </Typography>
                                <Box sx={{
                                    display: 'grid',
                                    gridTemplateColumns: { 
                                        xs: '1fr', 
                                        sm: 'repeat(2, 1fr)', 
                                        md: 'repeat(3, 1fr)' 
                                    },
                                    gap: 3,
                                    width: '100%',
                                }}>
                                    {artista.imagenes.map((imagen, index) => (
                                        <Box
                                            key={index}
                                            sx={{
                                                width: '100%',
                                                paddingBottom: '100%', // Aspect ratio 1:1
                                                position: 'relative',
                                                borderRadius: '12px',
                                                overflow: 'hidden',
                                                border: '2px solid rgba(212, 166, 70, 0.3)',
                                                '&:hover': {
                                                    border: '2px solid #D4A646',
                                                    transform: 'scale(1.02)',
                                                    transition: 'all 0.3s ease',
                                                }
                                            }}
                                        >
                                            <img
                                                src={imagen}
                                                alt={`${artista.nombre} ${index + 1}`}
                                                style={{
                                                    position: 'absolute',
                                                    top: 0,
                                                    left: 0,
                                                    width: '100%',
                                                    height: '100%',
                                                    objectFit: 'cover',
                                                }}
                                            />
                                        </Box>
                                    ))}
                                </Box>
                            </Box>
                        )}
                    </Box>
                </Box>
            </Modal>
        </Box>
    );
}, (prevProps, nextProps) => prevProps.artista.id === nextProps.artista.id);

Artista2026.displayName = 'Artista2026';

export default Artista2026;

